// import React, {
//   useState, useEffect, useRef, useCallback, useContext, useMemo,
// } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import {
//   Box, Card, CardContent, CardMedia, Typography, IconButton,
//   Button, Tooltip, Chip, CircularProgress, Tabs, Tab,
// } from '@mui/material';
// import {
//   FavoriteBorder, Share, LocationOn,
//   ChevronLeft, ChevronRight, ArrowForward,
// } from '@mui/icons-material';
// import buildingImage from './../../../Images/house.jpeg';
// import CustomSearchBar from './../Lease Module/CustomSearch';
// import CustomBottomNav from './CustomBottomNav.js';
// import GuestLoginModal from '../../GuestLoginModal';
// import { BASE_URL } from './../../Api/ApiUrls';
// import AddPropertyCards from '../AddsProducts/AddPropertyCards';

// const PAGE_SIZE = 20;
// const API_BASE = 'https://landnest.net:7000/api';

// const formatTotalPrice = (price) => {
//   const num = Number(String(price || '').replace(/[^0-9.]/g, ''));

//   if (isNaN(num) || num <= 0) return '0';

//   if (num >= 10000000) {
//     return `${(num / 10000000).toFixed(2).replace(/\.?0+$/, '')}CR`;
//   }

//   if (num >= 100000) {
//     return `${(num / 100000).toFixed(2).replace(/\.?0+$/, '')}L`;
//   }

//   if (num >= 1000) {
//     return `${(num / 1000).toFixed(2).replace(/\.?0+$/, '')}K`;
//   }

//   return num.toString();
// };

// const formatBudget = (min, max) => {
//   const fmt = (n) => {
//     if (!n) return '0';
//     if (n >= 10000000) return `${(n / 10000000).toFixed(2).replace(/\.00$/, '')} Cr`;
//     if (n >= 100000) return `${(n / 100000).toFixed(2).replace(/\.00$/, '')} L`;
//     if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, '')} K`;
//     return String(n);
//   };
//   if (!min && !max) return 'NA';
//   if (min === max || !max) return `₹${fmt(min)}`;
//   return `₹${fmt(min)} – ₹${fmt(max)}`;
// };

// const getAreaInfo = (property) => {
//   if (property.length && property.width) {
//     const sqft = property.length * property.width;
//     return { value: sqft.toLocaleString('en-IN'), unit: `sq.${property.units || 'ft'}` };
//   }
//   if (property.minAcres || property.maxAcres) {
//     const min = property.minAcres || 0;
//     const max = property.maxAcres || min;
//     const val = min === max ? String(min) : `${min}-${max}`;
//     return { value: val, unit: 'Acres' };
//   }
//   return { value: 'N/A', unit: '' };
// };

// const getPricePerUnit = (property) => {
//   const price = Number(property.effectivePrice || property.minBudget || 0);
//   if (!price) return null;
//   if (property.length && property.width) {
//     const sqft = property.length * property.width;
//     if (sqft > 0) return { value: Math.round(price / sqft), unit: 'sft' };
//   }
//   return null;
// };

// // ─── Parse API row → card shape ─────────────────────────────────────────────
// const parseJvJdProperty = (item) => {
//   if (!item) return null;
//   return {
//     id: String(item.id ?? ''),
//     title: item.propertyType || 'Property',
//     listingType: item.listingType || '',
//     status: item.status || '',
//     location: item.city || item.locality || 'Location not available',
//     locality: item.locality || '',
//     city: item.city || '',
//     facing: item.facing || '-',
//     postedBy: item.postedBy || item.posted_by || 'Agent',
//     minBudget: Number(item.minBudget) || 0,
//     maxBudget: Number(item.maxBudget) || 0,
//     effectivePrice: Number(item.effectivePrice) || Number(item.minBudget) || 0,
//     price: Number(item.price) || 0,
//     length: item.length || 0,
//     width: item.width || 0,
//     units: item.units || 'ft',
//     minAcres: item.minAcres ?? item.min_acres ?? 0,
//     maxAcres: item.maxAcres ?? item.max_acres ?? 0,
//     siteArea: item.siteArea || 0,
//     roadwidth: item.roadwidth || 0,
//     ratio: item.ratio || '',
//     lat: item.lat,
//     lng: item.lng,
//     userId: item.userId,
//     images: Array.isArray(item.property_images)
//       ? item.property_images.map(img => {
//           const raw = typeof img === 'string' ? img : (img?.image || '');
//           if (!raw) return buildingImage;
//           return raw.startsWith('http') ? raw : `${BASE_URL}/${raw.replace(/^\/+/, '')}`;
//         })
//       : [],
//     raw: item,
//   };
// };

// // ─── Skeleton card ──────────────────────────────────────────────────────────
// const SkeletonCard = () => (
//   <Box sx={{
//     mb: 1.2, mx: 2, borderRadius: 2, overflow: 'hidden', boxShadow: 2,
//     backgroundColor: '#fff', height: 170,
//     animation: 'skeletonPulse 1.5s ease-in-out infinite',
//     '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
//   }}>
//     <Box sx={{ display: 'flex', height: 170 }}>
//       <Box sx={{ width: '38%', backgroundColor: '#ddd' }} />
//       <Box sx={{ width: '62%', p: 1 }}>
//         <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '65%' }} />
//         <Box sx={{ height: 10, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '45%' }} />
//         <Box sx={{ height: 10, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1.5, width: '55%' }} />
//         <Box sx={{ display: 'flex', gap: 1 }}>
//           <Box sx={{ flex: 1, height: 26, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//           <Box sx={{ flex: 1, height: 26, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//           <Box sx={{ flex: 1, height: 26, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//         </Box>
//       </Box>
//     </Box>
//   </Box>
// );

// const ChipRowSkeleton = () => (
//   <Box sx={{ display: 'flex', gap: 0.6, px: 0, pb: 1, overflowX: 'hidden' }}>
//     {[80, 60, 100, 70].map((w, i) => (
//       <Box key={i} sx={{
//         width: w, height: 24, borderRadius: '20px', flexShrink: 0,
//         backgroundColor: '#d0d0d0',
//         animation: 'skeletonPulse 1.5s ease-in-out infinite',
//         '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
//       }} />
//     ))}
//   </Box>
// );

// // ─── Debounce hook ──────────────────────────────────────────────────────────
// const useDebounce = (value, delay) => {
//   const [debounced, setDebounced] = useState(value);
//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(value), delay);
//     return () => clearTimeout(t);
//   }, [value, delay]);
//   return debounced;
// };

// // ─── Main Component ─────────────────────────────────────────────────────────
// const JvJdPropertyList = () => {
//   const navigate = useNavigate();
//   const { isGuest, userId } = useContext(AuthContext);

//   const [activeTab, setActiveTab] = useState('jvjd'); 

//   // UI state
//   const [searchQuery, setSearchQuery] = useState('');
//   const [selectedType, setSelectedType] = useState(null);
//   const [selectedPropertyType, setSelectedPropertyType] = useState(null);
//   const [priceFilter, setPriceFilter] = useState(null);    
//   const [currentImageIndex, setCurrentImageIndex] = useState({});
//   const [showGuestModal, setShowGuestModal] = useState(false);
//   const [locationLoading, setLocationLoading] = useState({});

//   // Data state
//   const [allProperties, setAllProperties] = useState([]);
//   const [userActivities, setUserActivities] = useState([]);
//   const [filterOptions, setFilterOptions] = useState({
//     typeOptions: [],
//     propertyTypeOptions: [],
//     priceRange: { min: 0, max: 10000000000 },
//   });
//   const [filtersLoading, setFiltersLoading] = useState(true);
//   const [initialLoading, setInitialLoading] = useState(true);
//   const [isFetching, setIsFetching] = useState(false);
//   const [hasMore, setHasMore] = useState(false);

//   const debouncedSearch = useDebounce(searchQuery, 400);
//   const isTyping = searchQuery !== debouncedSearch;

//   // ── Fetch filter options once ─────────────────────────────────────────────
//   useEffect(() => {
//     let cancelled = false;
//     setFiltersLoading(true);

//     fetch(`${API_BASE}/properties/jvjd/jvjd/options/filters/`)
//       .then(r => r.json())
//       .then(data => {
//         if (cancelled) return;
//         setFilterOptions({
//           typeOptions: Array.isArray(data?.typeOptions) ? data.typeOptions : [],
//           propertyTypeOptions: Array.isArray(data?.propertyTypeOptions) ? data.propertyTypeOptions : [],
//           priceRange: data?.priceRange || { min: 0, max: 10000000000 },
//         });
//       })
//       .catch(err => {
//         console.error('Filter options error:', err);
//         if (!cancelled) {
//           setFilterOptions({
//             typeOptions: [],
//             propertyTypeOptions: [],
//             priceRange: { min: 0, max: 10000000000 },
//           });
//         }
//       })
//       .finally(() => { if (!cancelled) setFiltersLoading(false); });

//     return () => { cancelled = true; };
//   }, []);

//   // ── Fetch user activities once (for Accessed tab) ─────────────────────────
//   useEffect(() => {
//     if (!userId || isGuest) {
//       setUserActivities([]);
//       return;
//     }
//     let cancelled = false;
//     (async () => {
//       try {
//         const res = await fetch(`${BASE_URL}/activities/`);
//         if (!res.ok) throw new Error(`HTTP ${res.status}`);
//         const all = await res.json();
//         if (cancelled) return;
//         setUserActivities(
//           Array.isArray(all)
//             ? all.filter(a => a && String(a.user_id) === String(userId))
//             : []
//         );
//       } catch (e) {
//         console.error('Activities error:', e);
//         if (!cancelled) setUserActivities([]);
//       }
//     })();
//     return () => { cancelled = true; };
//   }, [userId, isGuest]);

//   // ── Fetch JV/JD properties whenever filters change ────────────────────────
//   useEffect(() => {
//     if (activeTab === 'accessed') return;

//     let cancelled = false;

//     const fetchData = async () => {
//       setIsFetching(true);
//       if (allProperties.length === 0) setInitialLoading(true);

//       const params = new URLSearchParams();
//       params.append('limit', PAGE_SIZE);

//       // ✅ Main type (jv/jd / build to suit)
//       if (selectedType) params.append('type', selectedType);

//       // ✅ Sub type (Land / Villas / Layouts)
//       if (selectedPropertyType) params.append('property_type', selectedPropertyType);

//       // ✅ Search
//       if (debouncedSearch && debouncedSearch.trim()) {
//         params.append('search', debouncedSearch.trim());
//       }

//       // ✅ Price range
//       if (priceFilter?.min != null) params.append('min_price', priceFilter.min);
//       if (priceFilter?.max != null) params.append('max_price', priceFilter.max);

//       const url = `${API_BASE}/properties/jvjd/jvjd/non-admin/?${params.toString()}`;
//       console.log('🎯 JV/JD URL:', url);

//       try {
//         const res = await fetch(url);
//         const data = await res.json();
//         if (cancelled) return;

//         const arr = Array.isArray(data?.data) ? data.data : [];
//         const parsed = arr.map(parseJvJdProperty).filter(Boolean);
//         setAllProperties(parsed);
//         setHasMore(!!data?.has_more);
//       } catch (e) {
//         console.error('JV/JD fetch error:', e);
//         if (!cancelled) setAllProperties([]);
//       } finally {
//         if (!cancelled) {
//           setInitialLoading(false);
//           setIsFetching(false);
//         }
//       }
//     };

//     fetchData();
//     return () => { cancelled = true; };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedType, selectedPropertyType, debouncedSearch, activeTab, priceFilter]);   // ✅ priceFilter in deps

//   // Compute which properties are accessed by the user
//   const accessedProperties = useMemo(() => {
//     if (!userActivities.length || !allProperties.length) return [];
//     const accessedIds = new Set(
//       userActivities
//         .filter(a => a && a.activity_as === 'Buyer' && a.property_id != null)
//         .map(a => String(a.property_id))
//     );
//     return allProperties.filter(p => p && p.id != null && accessedIds.has(String(p.id)));
//   }, [allProperties, userActivities]);

//   // Final list shown to user (based on active tab)
//   const properties = useMemo(() => {
//     const list = activeTab === 'accessed' ? accessedProperties : allProperties;
//     return Array.isArray(list) ? list.filter(Boolean) : [];
//   }, [activeTab, accessedProperties, allProperties]);

//   // Init image indexes
//   useEffect(() => {
//     setCurrentImageIndex(prev => {
//       let changed = false;
//       const next = { ...prev };
//       properties.forEach(p => {
//         if (p && p.id != null && !(p.id in next)) {
//           next[p.id] = 0;
//           changed = true;
//         }
//       });
//       return changed ? next : prev;
//     });
//   }, [properties]);

//   const showSkeleton = activeTab === 'jvjd' && (isTyping || isFetching);

//   // ── Handlers ──────────────────────────────────────────────────────────────
//   const requireLogin = useCallback((e, cb) => {
//     e.stopPropagation();
//     if (isGuest) { setShowGuestModal(true); return; }
//     cb();
//   }, [isGuest]);

//   const handleCardClick = useCallback((property) => (e) => {
//     if (!property || property.id == null) return;
//     if (e.target.closest('button') || e.target.closest('svg')) return;
//     if (isGuest) { setShowGuestModal(true); return; }
//     navigate(`/jv-jv-property-detail/${property.id}`, {
//       state: { propertyId: property.id, property: property.raw },
//     });
//   }, [isGuest, navigate]);

//   const handleViewDetails = useCallback((property) => (e) => {
//     e.stopPropagation();
//     if (!property || property.id == null) return;
//     if (isGuest) { setShowGuestModal(true); return; }
//     navigate(`/jv-jv-property-detail/${property.id}`, {
//       state: { propertyId: property.id, property: property.raw },
//     });
//   }, [isGuest, navigate]);

//   const handleAction = useCallback(async (e, propertyId, actionName, actionCallback) => {
//     e.stopPropagation();
//     try {
//       await actionCallback();
//     } catch (err) {
//       console.error(`${actionName} error:`, err);
//     }
//   }, []);

//   const handleLocationClick = useCallback((property) => (e) => {
//     e.stopPropagation();
//     if (!property || property.id == null) return;
//     if (isGuest) { setShowGuestModal(true); return; }

//     handleAction(e, property.id, 'Location', async () => {
//       setLocationLoading(prev => ({ ...prev, [property.id]: true }));

//       const fallback = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location || '')}`;
//       const open = (url) => {
//         setLocationLoading(prev => ({ ...prev, [property.id]: false }));
//         window.open(url, '_blank', 'noopener,noreferrer');
//       };

//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           ({ coords }) => {
//             const dest = property.lat && property.lng
//               ? `https://www.google.com/maps/dir/?api=1&origin=${coords.latitude},${coords.longitude}&destination=${property.lat},${property.lng}&travelmode=driving`
//               : fallback;
//             open(dest);
//           },
//           () => open(fallback),
//           { timeout: 10000 }
//         );
//       } else {
//         open(fallback);
//       }
//     });
//   }, [handleAction, isGuest]);

//   const handleFavourite = useCallback((property) => (e) => {
//     e.stopPropagation();
//     if (isGuest) { setShowGuestModal(true); return; }
//     console.log('Favourite:', property?.id);
//   }, [isGuest]);

//   const handleShare = useCallback((property) => async (e) => {
//     e.stopPropagation();
//     if (!property || property.id == null) return;
//     const url = `${window.location.origin}/jv-jv-property-detail/${property.id}`;
//     try {
//       await navigator.clipboard.writeText(url);
//     } catch {
//       const ta = document.createElement('textarea');
//       ta.value = url; document.body.appendChild(ta); ta.select();
//       document.execCommand('copy'); document.body.removeChild(ta);
//     }
//   }, []);

//   // ── Card renderer ─────────────────────────────────────────────────────────
//   const renderCard = useCallback((property) => {
//     if (!property || property.id == null) return null;

//     const imgIdx = currentImageIndex[property.id] || 0;
//     const images = property.images?.length ? property.images : [buildingImage];

//     const postedBy = property.postedBy || property.posted_by || 'Agent';
//     const facing   = property.facing   || '-';

//     const priceValue =
//       property.effectivePrice ??
//       property.minBudget ??
//       property.price ??
//       0;

//     const locationText =
//       property.location || property.locality || 'Location not available';

//     return (
//       <Card
//         key={property.id}
//         onClick={handleCardClick(property)}
//         sx={{
//           mb: 1.2, mx: 2, borderRadius: 2, boxShadow: 2,
//           display: 'flex', flexDirection: 'row',
//           width: 'auto', height: 170, overflow: 'hidden',
//           transition: 'transform 0.2s ease-in-out',
//           '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
//           bgcolor: '#fff', flexShrink: 0, cursor: 'pointer',
//         }}
//       >
//         {/* LEFT: Image 38% */}
//         <Box sx={{ position: 'relative', width: '38%', minWidth: '38%', height: '100%', overflow: 'hidden' }}>
//           <CardMedia
//             component="img"
//             image={images[imgIdx]}
//             alt={property.title}
//             onError={(e) => { e.target.src = buildingImage; }}
//             sx={{
//               width: '100%', height: '100%', objectFit: 'cover',
//               borderTopLeftRadius: 8, borderBottomLeftRadius: 8,
//             }}
//           />

//           <Tooltip title="Add to Wishlist">
//             <IconButton
//               onClick={handleFavourite(property)}
//               sx={{
//                 position: 'absolute', top: 7, right: 3,
//                 bgcolor: 'white', boxShadow: 1, p: 0.5, width: 24, height: 24,
//                 '&:hover': { bgcolor: '#f5f5f5' },
//               }}
//             >
//               <FavoriteBorder sx={{ fontSize: '1rem', color: '#c98a2c' }} />
//             </IconButton>
//           </Tooltip>

//           {property.listingType && (
//             <Box sx={{
//               position: 'absolute', top: 7, left: 5,
//               bgcolor: 'rgba(0,0,0,0.65)', color: '#fff',
//               px: 0.7, py: 0.2, borderRadius: '3px',
//               fontSize: '0.55rem', fontWeight: 600,
//               textTransform: 'uppercase',
//             }}>
//               {property.listingType}
//             </Box>
//           )}
//         </Box>

//         {/* RIGHT: Content 62% */}
//         <CardContent
//           sx={{
//             width: '62%', p: 1,
//             display: 'flex', flexDirection: 'column',
//             justifyContent: 'space-between',
//             height: 170, boxSizing: 'border-box',
//             '&:last-child': { pb: 1 },
//           }}
//         >
//           {/* Title + Share */}
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.2 }}>
//             <Typography
//               fontWeight="bold" noWrap
//               sx={{
//                 flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis',
//                 fontSize: '0.75rem', lineHeight: 1.2, color: '#2C1810', mr: 0.3,
//               }}
//             >
//               {property.title}
//             </Typography>
//             <IconButton
//               onClick={handleShare(property)}
//               size="small"
//               sx={{
//                 width: 25, height: 25, p: 0, flexShrink: 0,
//                 bgcolor: '#FFFFFF', boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
//                 '&:hover': { bgcolor: '#F5EDE4' },
//               }}
//             >
//               <Share sx={{ fontSize: 14, color: '#8D6E63' }} />
//             </IconButton>
//           </Box>

//           {/* Budget per Acre (centered) */}
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 0.1, mb: 0.2 }}>
//             <Box sx={{ textAlign: 'center', minWidth: 0 }}>
//               <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
//                 Budget per Acre
//               </Typography>
//               <Typography fontWeight="bold" sx={{ fontSize: '0.9rem', lineHeight: 1.2, color: '#1F1F1F' }}>
//                 ₹{formatTotalPrice(priceValue)}
//               </Typography>
//             </Box>
//           </Box>

//           {/* Location */}
//           <Box
//             onClick={handleLocationClick(property)}
//             role="button"
//             tabIndex={0}
//             sx={{
//               display: 'flex', alignItems: 'flex-start', gap: 0.5,
//               mt: 0.1, mb: 0.1, cursor: 'pointer',
//               borderRadius: 1, px: 0.3,
//               transition: 'background-color 0.15s',
//               '&:hover': { backgroundColor: 'rgba(201,138,44,0.10)' },
//             }}
//           >
//             {locationLoading[property.id] ? (
//               <CircularProgress size={14} sx={{ mt: 0.15, flexShrink: 0 }} />
//             ) : (
//               <LocationOn sx={{ fontSize: '0.9rem', color: '#8B4F16', flexShrink: 0, mt: 0.15 }} />
//             )}
//             <Typography
//               sx={{
//                 minWidth: 0, flex: 1,
//                 fontSize: '0.6rem',
//                 color: '#333',
//                 fontWeight: 500,
//                 lineHeight: 1.2,
//                 overflow: 'hidden',
//                 display: '-webkit-box',
//                 WebkitLineClamp: 2,
//                 WebkitBoxOrient: 'vertical',
//                 textOverflow: 'ellipsis',
//                 whiteSpace: 'normal',
//                 textDecoration: 'underline',
//                 textDecorationColor: 'rgba(201,138,44,0.4)',
//               }}
//             >
//               {locationText}
//             </Typography>
//           </Box>

//           {/* Info Grid */}
//           <Box
//             sx={{
//               display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//               mt: 0.2, mb: 0.2,
//               border: '1px solid #e0e0e0',
//               borderRadius: '8px', overflow: 'hidden', minHeight: 30,
//             }}
//           >
//             <Box sx={{ flex: 1.2, minWidth: 0, textAlign: 'center', p: 0.4, borderRight: '1px solid #e0e0e0' }}>
//               <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.62rem', lineHeight: 1.1, fontweight: 900 }}>
//                 {postedBy}
//               </Typography>
//             </Box>

//             <Box sx={{ flex: 1, minWidth: 0, textAlign: 'center', p: 0.3 }}>
//               <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.62rem', lineHeight: 1.1, fontweight: 900 }}>
//                 {facing}
//               </Typography>
//               <Typography noWrap sx={{ fontSize: '0.55rem', lineHeight: 1.1, color: '#666' }}>
//                 Facing
//               </Typography>
//             </Box>
//           </Box>

//           {/* View Details */}
//           <Button
//             variant="contained"
//             size="small"
//             fullWidth
//             onClick={handleViewDetails(property)}
//             sx={{
//               mt: 0.2, py: 0.18,
//               fontSize: '0.7rem', fontWeight: 600,
//               bgcolor: '#8B4F16', color: '#fff',
//               borderRadius: '2px',
//               '&:hover': { bgcolor: '#f5f5f5' },
//               textTransform: 'none',
//               minHeight: 22,
//               display: 'flex', justifyContent: 'space-between',
//               alignItems: 'center', px: 1.5,
//             }}
//           >
//             View Details
//             <ArrowForward sx={{ fontSize: '0.9rem' }} />
//           </Button>
//         </CardContent>
//       </Card>
//     );
//   }, [
//     currentImageIndex, locationLoading, handleCardClick, handleViewDetails,
//     handleLocationClick, handleFavourite, handleShare,
//   ]);

//   // ── Main chips (typeOptions) ─────────────────────────────────────────────
//   const renderTypeChips = () => (
//     <Box
//       sx={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         gap: 0.6,
//         overflowX: 'auto',
//         flexWrap: 'nowrap',
//         pb: 0.5,
//         '&::-webkit-scrollbar': { display: 'none' },
//         scrollbarWidth: 'none',
//         msOverflowStyle: 'none',
//       }}
//     >
//       {(filterOptions.typeOptions || []).map((opt) => {
//         if (!opt || opt.value == null) return null;
//         const isActive = selectedType === opt.value;
//         return (
//           <Chip
//             key={`type:${opt.value}`}
//             label={opt.label ?? String(opt.value)}
//             onClick={() => setSelectedType(prev => prev === opt.value ? null : opt.value)}
//             sx={{
//               flexShrink: 0,
//               height: 24,
//               borderRadius: '20px',
//               fontWeight: 'bold',
//               fontSize: '13px',
//               bgcolor: isActive ? '#8B4F16' : 'transparent',
//               color: isActive ? '#fff' : '#000',
//               border: '1px solid black',
//               transition: 'all 0.2s ease',
//               cursor: 'pointer',
//               '&:hover': {
//                 bgcolor: isActive ? '#333' : '#e0e0e0',
//                 transform: 'scale(1.02)',
//               },
//               '& .MuiChip-label': { paddingLeft: '6px', paddingRight: '6px', lineHeight: 1 },
//             }}
//           />
//         );
//       })}
//     </Box>
//   );

//   // ── Sub chips (propertyTypeOptions) ──────────────────────────────────────
//   const renderPropertyTypeChips = () => (
//     <Box
//       sx={{
//         display: 'flex',
//         gap: 0.6,
//         overflowX: 'auto',
//         flexWrap: 'nowrap',
//         pb: 0.5,
//         '&::-webkit-scrollbar': { display: 'none' },
//         scrollbarWidth: 'none',
//         msOverflowStyle: 'none',
//       }}
//     >
//       {(filterOptions.propertyTypeOptions || []).map((opt) => {
//         if (!opt || opt.value == null) return null;
//         const isActive = selectedPropertyType === opt.value;
//         return (
//           <Chip
//             key={`propertyType:${opt.value}`}
//             label={opt.label ?? String(opt.value)}
//             onClick={() => setSelectedPropertyType(prev => prev === opt.value ? null : opt.value)}
//             sx={{
//               flexShrink: 0,
//               height: 24,
//               borderRadius: '20px',
//               fontWeight: 'bold',
//               fontSize: '13px',
//               bgcolor: isActive ? '#8B4F16' : 'transparent',
//               color: isActive ? '#fff' : '#000',
//               border: '1px solid black',
//               transition: 'all 0.2s ease',
//               cursor: 'pointer',
//               '&:hover': {
//                 bgcolor: isActive ? '#333' : '#e0e0e0',
//                 transform: 'scale(1.02)',
//               },
//               '& .MuiChip-label': { paddingLeft: '6px', paddingRight: '6px', lineHeight: 1 },
//             }}
//           />
//         );
//       })}
//     </Box>
//   );

//   // ── Properties section ────────────────────────────────────────────────────
//   const renderPropertiesSection = useMemo(() => {
//     if (activeTab === 'jvjd' && initialLoading) {
//       return (
//         <Box sx={{ mt: 1 }}>
//           {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
//         </Box>
//       );
//     }

//     if (activeTab === 'jvjd' && showSkeleton) {
//       return (
//         <Box>
//           {isTyping && (
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, py: 1.5 }}>
//               <CircularProgress size={16} sx={{ color: '#8B7355' }} />
//               <Typography variant="caption" sx={{ color: '#888' }}>Searching...</Typography>
//             </Box>
//           )}
//           <Box sx={{ mt: isTyping ? 0.5 : 1 }}>
//             {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
//           </Box>
//         </Box>
//       );
//     }

//     if (properties.length === 0) {
//       return (
//         <Box sx={{
//           display: 'flex', flexDirection: 'column', justifyContent: 'center',
//           alignItems: 'center', height: 200, gap: 1, px: 2,
//         }}>
//           <Typography variant="body2" color="text.secondary">
//             {activeTab === 'accessed'
//               ? "You haven't accessed any JV/JD properties yet"
//               : selectedType || selectedPropertyType || priceFilter
//                 ? 'No JV/JD properties match your filters.'
//                 : debouncedSearch
//                   ? `No results for "${debouncedSearch}"`
//                   : 'No JV/JD properties available right now.'}
//           </Typography>
//         </Box>
//       );
//     }

//     return (
//       <>
//         {properties.filter(Boolean).map((property, index) => (
//           <React.Fragment key={property.id}>
//             {renderCard(property)}
//             {index === 1 && (
//               <Box sx={{ mb: 1.2 }}>
//                 <AddPropertyCards panel="jvjd" />
//               </Box>
//             )}
//           </React.Fragment>
//         ))}
//         {activeTab === 'jvjd' && hasMore && (
//           <Box sx={{ py: 3, display: 'flex', justifyContent: 'center' }}>
//             <CircularProgress size={28} sx={{ color: '#8B7355' }} />
//           </Box>
//         )}
//         {activeTab === 'jvjd' && !hasMore && (
//           <Box sx={{ py: 3, display: 'flex', justifyContent: 'center' }}>
//             <Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic' }}>
//               ✓ All properties loaded
//             </Typography>
//           </Box>
//         )}
//       </>
//     );
//   }, [
//     activeTab, initialLoading, showSkeleton, isTyping, properties,
//     selectedType, selectedPropertyType, debouncedSearch, renderCard, hasMore, priceFilter,
//   ]);

//   // ── JSX ───────────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>
//       {/* Fixed header */}
//       <Box sx={{
//         position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200,
//         backgroundColor: 'rgb(239, 231, 221)',
//       }}>
//         <Box sx={{ px: 1, pt: 1, pb: 0.25 }}>
//           <CustomSearchBar
//   value={searchQuery}
//   onChange={e => setSearchQuery(e.target.value)}
//   onPriceFilterChange={(val) => {
//     console.log('💰 onPriceFilterChange received:', val);
//     // normalize shape — accept both {min,max} and null
//     if (val && typeof val === 'object' && (val.min != null || val.max != null)) {
//       setPriceFilter({ min: val.min ?? 0, max: val.max ?? 10000000000 });
//     } else {
//       setPriceFilter(null);
//     }
//   }}
// />
//         </Box>

//         {/* Two tabs */}
//         <Box sx={{ px: 2, pt: 0, pb: 0.5 }}>
//           <Tabs
//             value={activeTab}
//             onChange={(e, newValue) => {
//               setActiveTab(newValue);
//               if (newValue === 'accessed') {
//                 setSelectedType(null);
//                 setSelectedPropertyType(null);
//                 setPriceFilter(null);
//               }
//             }}
//             sx={{ minHeight: 36, '& .MuiTabs-indicator': { backgroundColor: '#B66A18', height: 3 } }}
//           >
//             <Tab
//               label="JV/JD Properties"
//               value="jvjd"
//               sx={{
//                 textTransform: 'none', fontWeight: 'bold',
//                 minWidth: 0, mr: 2, minHeight: 36, py: 0.5,
//                 color: 'text.secondary',
//                 '&.Mui-selected': { color: '#8B4F16' },
//               }}
//             />
//             <Tab
//               label="Accessed Properties"
//               value="accessed"
//               sx={{
//                 textTransform: 'none', fontWeight: 'bold',
//                 minWidth: 0, minHeight: 36, py: 0.5,
//                 color: 'text.secondary',
//                 '&.Mui-selected': { color: '#8B4F16' },
//               }}
//             />
//           </Tabs>
//         </Box>

//         {/* Two chip rows */}
//         {activeTab === 'jvjd' && (
//           <>
//             <Box sx={{ px: 2, pt: 0, pb: 0.25 }}>
//               {filtersLoading ? <ChipRowSkeleton /> : renderTypeChips()}
//             </Box>

//             <Box sx={{ px: 2, pt: 0, pb: 0.5 }}>
//               {filtersLoading ? <ChipRowSkeleton /> : renderPropertyTypeChips()}
//             </Box>
//           </>
//         )}
//       </Box>

//       {/* Scrollable list */}
//       <Box
//         sx={{
//           pb: 8,
//           pt: activeTab === 'jvjd'
//             ? { xs: '155px', sm: '160px' }
//             : { xs: '100px', sm: '92px' },
//         }}
//       >
//         {renderPropertiesSection}
//       </Box>

//       <GuestLoginModal open={showGuestModal} onClose={() => setShowGuestModal(false)} />
//       <CustomBottomNav />
//     </Box>
//   );
// };

// export default JvJdPropertyList;


import React, {
  useState, useEffect, useRef, useCallback, useContext, useMemo,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './../../AuthContext/AuthContext';
import {
  Box, Card, CardContent, CardMedia, Typography, IconButton,
  Button, Tooltip, Chip, CircularProgress, Tabs, Tab,
} from '@mui/material';
import {
  FavoriteBorder, Favorite, Share, LocationOn,
  ChevronLeft, ChevronRight, ArrowForward,
} from '@mui/icons-material';
import axios from 'axios';
import buildingImage from './../../../Images/house.jpeg';
import CustomSearchBar from './../Lease Module/CustomSearch';
import CustomBottomNav from './CustomBottomNav.js';
import GuestLoginModal from '../../GuestLoginModal';
import { BASE_URL } from './../../Api/ApiUrls';

// ─── Import the hook + component (panel="jv") ───────────────────────────────
import AddPropertyCards, { useAdsForPanel } from '../AddsProducts/AddPropertyCards';

import LocationModal from '../Buy Module/LocationModal';
import ShareModal from '../Buy Module/ShareModal';
import AlertModal from '../Buy Module/AlertModal';

const PAGE_SIZE = 20;
const API_BASE = 'https://landnest.net:7000/api';

const formatTotalPrice = (price) => {
  const num = Number(String(price || '').replace(/[^0-9.]/g, ''));
  if (isNaN(num) || num <= 0) return '0';
  if (num >= 10000000) {
    return `${(num / 10000000).toFixed(2).replace(/\.?0+$/, '')}CR`;
  }
  if (num >= 100000) {
    return `${(num / 100000).toFixed(2).replace(/\.?0+$/, '')}L`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(2).replace(/\.?0+$/, '')}K`;
  }
  return num.toString();
};

const formatBudget = (min, max) => {
  const fmt = (n) => {
    if (!n) return '0';
    if (n >= 10000000) return `${(n / 10000000).toFixed(2).replace(/\.00$/, '')} Cr`;
    if (n >= 100000) return `${(n / 100000).toFixed(2).replace(/\.00$/, '')} L`;
    if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, '')} K`;
    return String(n);
  };
  if (!min && !max) return 'NA';
  if (min === max || !max) return `₹${fmt(min)}`;
  return `₹${fmt(min)} – ₹${fmt(max)}`;
};

const getAreaInfo = (property) => {
  if (property.length && property.width) {
    const sqft = property.length * property.width;
    return { value: sqft.toLocaleString('en-IN'), unit: `sq.${property.units || 'ft'}` };
  }
  if (property.minAcres || property.maxAcres) {
    const min = property.minAcres || 0;
    const max = property.maxAcres || min;
    const val = min === max ? String(min) : `${min}-${max}`;
    return { value: val, unit: 'Acres' };
  }
  return { value: 'N/A', unit: '' };
};

const getPricePerUnit = (property) => {
  const price = Number(property.effectivePrice || property.minBudget || 0);
  if (!price) return null;
  if (property.length && property.width) {
    const sqft = property.length * property.width;
    if (sqft > 0) return { value: Math.round(price / sqft), unit: 'sft' };
  }
  return null;
};

const formatDistance = (km) =>
  km < 1 ? `${Math.round(km * 1000)} m away` : `${km.toFixed(1)} km away`;

// ─── Parse API row → card shape ─────────────────────────────────────────────
const parseJvJdProperty = (item) => {
  if (!item) return null;
  return {
    id: String(item.id ?? ''),
    title: item.propertyType || 'Property',
    listingType: item.listingType || '',
    status: item.status || '',
    location: item.city || item.locality || 'Location not available',
    locality: item.locality || '',
    city: item.city || '',
    facing: item.facing || '-',
    postedBy: item.postedBy || item.posted_by || 'Agent',
    mobile_no: item.mobile_no || item.mobile || item.phone || '',
    minBudget: Number(item.minBudget) || 0,
    maxBudget: Number(item.maxBudget) || 0,
    effectivePrice: Number(item.effectivePrice) || Number(item.minBudget) || 0,
    price: Number(item.price) || 0,
    length: item.length || 0,
    width: item.width || 0,
    units: item.units || 'ft',
    minAcres: item.minAcres ?? item.min_acres ?? 0,
    maxAcres: item.maxAcres ?? item.max_acres ?? 0,
    siteArea: item.siteArea || 0,
    roadwidth: item.roadwidth || 0,
    ratio: item.ratio || '',
    lat: item.lat,
    lng: item.lng,
    distance_km: item.distance_km != null ? Number(item.distance_km) : null,
    userId: item.userId,
    images: Array.isArray(item.property_images)
      ? item.property_images.map(img => {
          const raw = typeof img === 'string' ? img : (img?.image || '');
          if (!raw) return buildingImage;
          return raw.startsWith('http') ? raw : `${BASE_URL}/${raw.replace(/^\/+/, '')}`;
        })
      : [],
    raw: item,
  };
};

// ─── Skeleton card ──────────────────────────────────────────────────────────
const SkeletonCard = () => (
  <Box sx={{
    mb: 1.2, mx: 2, borderRadius: 2, overflow: 'hidden', boxShadow: 2,
    backgroundColor: '#fff', height: 170,
    animation: 'skeletonPulse 1.5s ease-in-out infinite',
    '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
  }}>
    <Box sx={{ display: 'flex', height: 170 }}>
      <Box sx={{ width: '38%', backgroundColor: '#ddd' }} />
      <Box sx={{ width: '62%', p: 1 }}>
        <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '65%' }} />
        <Box sx={{ height: 10, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '45%' }} />
        <Box sx={{ height: 10, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1.5, width: '55%' }} />
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box sx={{ flex: 1, height: 26, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
          <Box sx={{ flex: 1, height: 26, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
          <Box sx={{ flex: 1, height: 26, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
        </Box>
      </Box>
    </Box>
  </Box>
);

const ChipRowSkeleton = () => (
  <Box sx={{ display: 'flex', gap: 0.6, px: 0, pb: 1, overflowX: 'hidden' }}>
    {[80, 60, 100, 70].map((w, i) => (
      <Box key={i} sx={{
        width: w, height: 24, borderRadius: '20px', flexShrink: 0,
        backgroundColor: '#d0d0d0',
        animation: 'skeletonPulse 1.5s ease-in-out infinite',
        '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
      }} />
    ))}
  </Box>
);

// ─── Scroll sentinel (infinite scroll) ──────────────────────────────────────
const ScrollSentinel = ({ onVisible, hasMore, loading }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting && hasMore && !loading) onVisible(); },
      { threshold: 0.1, rootMargin: '200px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [onVisible, hasMore, loading]);

  return (
    <Box ref={ref} sx={{ py: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {loading && <CircularProgress size={28} sx={{ color: '#8B7355' }} />}
      {!loading && !hasMore && (
        <Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic' }}>
          ✓ All properties loaded
        </Typography>
      )}
    </Box>
  );
};

// ─── Debounce hook ──────────────────────────────────────────────────────────
const useDebounce = (value, delay) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};

// ─── User coordinates (from localStorage) ───────────────────────────────────
const readUserCoords = () => {
  const lat = parseFloat(localStorage.getItem('userLatitude'));
  const lng = parseFloat(localStorage.getItem('userLongitude'));
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat: Math.round(lat * 1000) / 1000, lng: Math.round(lng * 1000) / 1000 };
};

const useUserCoords = () => {
  const [coords, setCoords] = useState(readUserCoords);
  useEffect(() => {
    const refresh = () =>
      setCoords(prev => {
        const next = readUserCoords();
        const same = prev?.lat === next?.lat && prev?.lng === next?.lng;
        return same ? prev : next; // keep reference stable → no needless refetch
      });
    window.addEventListener('storage', refresh);
    window.addEventListener('focus', refresh);
    return () => {
      window.removeEventListener('storage', refresh);
      window.removeEventListener('focus', refresh);
    };
  }, []);
  return coords;
};

// ─── Main Component ─────────────────────────────────────────────────────────
const JvJdPropertyList = () => {
  const navigate = useNavigate();
  const { isGuest, userId } = useContext(AuthContext);

  const [activeTab, setActiveTab] = useState('jvjd');

  // UI state
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedType, setSelectedType] = useState(null);
  const [selectedPropertyType, setSelectedPropertyType] = useState(null);
  const [priceFilter, setPriceFilter] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [showGuestModal, setShowGuestModal] = useState(false);
  const [locationLoading, setLocationLoading] = useState({});

  // Wishlist / cart
  const [savedProperties, setSavedProperties] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [saving, setSaving] = useState({});

  // Modals (Share + Location)
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [currentPropertyData, setCurrentPropertyData] = useState(null);

  // Data state
  const [allProperties, setAllProperties] = useState([]);
  const [userActivities, setUserActivities] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    typeOptions: [],
    propertyTypeOptions: [],
    priceRange: { min: 0, max: 10000000000 },
  });
  const [filtersLoading, setFiltersLoading] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(false);

  // Pagination (nearby cursor)
  const [cursor, setCursor] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);
  const versionRef = useRef(0); // ignores late "load more" responses after filters change

  const [showWishlistSuccess, setShowWishlistSuccess] = useState(false);
  const [wishlistSuccessMsg, setWishlistSuccessMsg] = useState({
    title: 'Added to Wishlist',
    message: 'This property has been added to your Wishlist.',
  });

  // ─── Ads hook (panel="jv", shared, fetched once) ────────────────────────
  const { ads: jvAds, loading: adsLoading } = useAdsForPanel('jv');

  const coords = useUserCoords();
  const debouncedSearch = useDebounce(searchQuery, 400);
  const isTyping = searchQuery !== debouncedSearch;

  // ── Fetch filter options once ─────────────────────────────────────────────
  useEffect(() => {
    let cancelled = false;
    setFiltersLoading(true);

    fetch(`${API_BASE}/properties/jvjd/jvjd/options/filters/`)
      .then(r => r.json())
      .then(data => {
        if (cancelled) return;
        setFilterOptions({
          typeOptions: Array.isArray(data?.typeOptions) ? data.typeOptions : [],
          propertyTypeOptions: Array.isArray(data?.propertyTypeOptions) ? data.propertyTypeOptions : [],
          priceRange: data?.priceRange || { min: 0, max: 10000000000 },
        });
      })
      .catch(err => {
        console.error('Filter options error:', err);
        if (!cancelled) {
          setFilterOptions({
            typeOptions: [],
            propertyTypeOptions: [],
            priceRange: { min: 0, max: 10000000000 },
          });
        }
      })
      .finally(() => { if (!cancelled) setFiltersLoading(false); });

    return () => { cancelled = true; };
  }, []);

  // ── Fetch user activities + cart (for Accessed tab + Wishlist) ────────────
  useEffect(() => {
    if (!userId || isGuest) {
      setUserActivities([]);
      setSavedProperties([]);
      setCartItems([]);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(`${BASE_URL}/activities/`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const all = await res.json();
        if (cancelled) return;
        setUserActivities(
          Array.isArray(all)
            ? all.filter(a => a && String(a.user_id) === String(userId))
            : []
        );
      } catch (e) {
        console.error('Activities error:', e);
        if (!cancelled) setUserActivities([]);
      }
    })();

    // Cart / wishlist
    axios.get(`${BASE_URL}/get-user-cart/${userId}/`)
      .then(r => {
        if (cancelled) return;
        const items = Array.isArray(r.data) ? r.data : [];
        setCartItems(items);
        setSavedProperties(items.map(i => String(i.property_id)));
      })
      .catch(e => {
        console.error('Cart error:', e);
        if (!cancelled) {
          setCartItems([]);
          setSavedProperties([]);
        }
      });

    return () => { cancelled = true; };
  }, [userId, isGuest]);

  // ── Build the list URL (adds lat/lng + cursor) ────────────────────────────
  const buildUrl = useCallback((cursorVal) => {
    const params = new URLSearchParams();
    params.append('limit', PAGE_SIZE);
    if (cursorVal) params.append('cursor', cursorVal);
    if (coords) { params.append('lat', coords.lat); params.append('lng', coords.lng); }
    if (selectedType) params.append('type', selectedType);
    if (selectedPropertyType) params.append('property_type', selectedPropertyType);
    if (debouncedSearch && debouncedSearch.trim()) {
      params.append('search', debouncedSearch.trim());
    }
    if (priceFilter?.min != null) params.append('min_price', priceFilter.min);
    if (priceFilter?.max != null) params.append('max_price', priceFilter.max);
    return `${API_BASE}/properties/jvjd/jvjd/non-admin/?${params.toString()}`;
  }, [coords, selectedType, selectedPropertyType, debouncedSearch, priceFilter]);

  // ── First page (re-runs when any filter or the user's location changes) ───
  useEffect(() => {
    if (activeTab === 'accessed') return;

    let cancelled = false;
    versionRef.current += 1;

    (async () => {
      setIsFetching(true);
      if (allProperties.length === 0) setInitialLoading(true);

      try {
        const res = await fetch(buildUrl(null));
        const data = await res.json();
        if (cancelled) return;

        const arr = Array.isArray(data?.data) ? data.data : [];
        setAllProperties(arr.map(parseJvJdProperty).filter(Boolean));
        setCursor(data?.next_cursor ?? null);
        setHasMore(!!data?.has_more);
      } catch (e) {
        console.error('JV/JD fetch error:', e);
        if (!cancelled) setAllProperties([]);
      } finally {
        if (!cancelled) {
          setInitialLoading(false);
          setIsFetching(false);
        }
      }
    })();

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buildUrl, activeTab]);

  // ── Next pages ────────────────────────────────────────────────────────────
  const loadMore = useCallback(async () => {
    if (loadingMore || !hasMore || !cursor) return;
    const version = versionRef.current;
    setLoadingMore(true);
    try {
      const res = await fetch(buildUrl(cursor));
      const data = await res.json();
      if (version !== versionRef.current) return; // filters changed meanwhile

      const arr = Array.isArray(data?.data) ? data.data : [];
      const parsed = arr.map(parseJvJdProperty).filter(Boolean);
      setAllProperties(prev => {
        const seen = new Set(prev.map(p => p.id));
        return [...prev, ...parsed.filter(p => !seen.has(p.id))];
      });
      setCursor(data?.next_cursor ?? null);
      setHasMore(!!data?.has_more);
    } catch (e) {
      console.error('JV/JD loadMore error:', e);
    } finally {
      setLoadingMore(false);
    }
  }, [loadingMore, hasMore, cursor, buildUrl]);

  // Compute which properties are accessed by the user
  const accessedProperties = useMemo(() => {
    if (!userActivities.length || !allProperties.length) return [];
    const accessedIds = new Set(
      userActivities
        .filter(a => a && a.activity_as === 'Buyer' && a.property_id != null)
        .map(a => String(a.property_id))
    );
    return allProperties.filter(p => p && p.id != null && accessedIds.has(String(p.id)));
  }, [allProperties, userActivities]);

  // Final list shown to user (based on active tab)
  const properties = useMemo(() => {
    const list = activeTab === 'accessed' ? accessedProperties : allProperties;
    return Array.isArray(list) ? list.filter(Boolean) : [];
  }, [activeTab, accessedProperties, allProperties]);

  // Init image indexes
  useEffect(() => {
    setCurrentImageIndex(prev => {
      let changed = false;
      const next = { ...prev };
      properties.forEach(p => {
        if (p && p.id != null && !(p.id in next)) {
          next[p.id] = 0;
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [properties]);

  const showSkeleton = activeTab === 'jvjd' && (isTyping || isFetching);

  // ── Helpers ───────────────────────────────────────────────────────────────
  const requireLogin = useCallback((e, cb) => {
    e.stopPropagation();
    if (isGuest) { setShowGuestModal(true); return; }
    cb();
  }, [isGuest]);

  const isSaved = useCallback(
    (property) => savedProperties.includes(String(property.id)),
    [savedProperties]
  );

  const addToCart = useCallback(async (propertyId) => {
    const r = await axios.post(`${BASE_URL}/user-cart/`, {
      user_id: userId,
      property_id: propertyId,
    });
    return r.data;
  }, [userId]);

  const removeFromCart = useCallback(async (cartId) => {
    await axios.delete(`${BASE_URL}/user-cart/${cartId}/`);
  }, []);

  const toggleSave = useCallback(async (property) => {
    const pid = String(property.id);
    setSaving(prev => ({ ...prev, [pid]: true }));
    try {
      if (isSaved(property)) {
        const item = cartItems.find(i => String(i.property_id) === pid);
        if (item?.cart_id) {
          await removeFromCart(item.cart_id);
        }
        setSavedProperties(prev => prev.filter(id => id !== pid));
        setCartItems(prev => prev.filter(i => String(i.property_id) !== pid));
      } else {
        const newItem = await addToCart(pid);
        const cartEntry = newItem?.data ?? newItem;
        setSavedProperties(prev => [...prev, pid]);
        setCartItems(prev => [...prev, cartEntry]);
      }
    } catch (e) {
      console.error('Save error:', e);
    } finally {
      setSaving(prev => ({ ...prev, [pid]: false }));
    }
  }, [isSaved, cartItems, addToCart, removeFromCart]);

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleCardClick = useCallback((property) => (e) => {
    if (!property || property.id == null) return;
    if (e.target.closest('button') || e.target.closest('svg')) return;
    if (isGuest) { setShowGuestModal(true); return; }
    navigate(`/jv-jv-property-detail/${property.id}`, {
      state: { propertyId: property.id, property: property.raw },
    });
  }, [isGuest, navigate]);

  const handleViewDetails = useCallback((property) => (e) => {
    e.stopPropagation();
    if (!property || property.id == null) return;
    if (isGuest) { setShowGuestModal(true); return; }
    navigate(`/jv-jv-property-detail/${property.id}`, {
      state: { propertyId: property.id, property: property.raw },
    });
  }, [isGuest, navigate]);

  // Wishlist (heart)
  const handleWishlistClick = useCallback((e, property) => {
    e.stopPropagation();
    requireLogin(e, async () => {
      const wasSaved = isSaved(property);
      await toggleSave(property);

      if (wasSaved) {
        setWishlistSuccessMsg({
          title: 'Removed from Wishlist',
          message: 'This property has been removed from your Wishlist.',
        });
      } else {
        setWishlistSuccessMsg({
          title: 'Added to Wishlist',
          message: 'This property has been added to your Wishlist.',
        });
      }
      setShowWishlistSuccess(true);
    });
  }, [requireLogin, isSaved, toggleSave]);

  // Share → open ShareModal
  const handleShareClick = useCallback((e, property) => {
    e.stopPropagation();
    requireLogin(e, () => {
      setCurrentPropertyData(property);
      setShowShareModal(true);
    });
  }, [requireLogin]);

  // Location → open LocationModal
  const handleLocationClick = useCallback((e, property) => {
    e.stopPropagation();
    requireLogin(e, () => {
      setCurrentPropertyData(property);
      setShowLocationModal(true);
    });
  }, [requireLogin]);

  // Called by LocationModal when user confirms "Open in Maps"
  const openGoogleMaps = useCallback(() => {
    if (!currentPropertyData) return;

    const pid = currentPropertyData.id;
    setLocationLoading(prev => ({ ...prev, [pid]: true }));

    const fallback = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      currentPropertyData.location || ''
    )}`;

    const open = (url) => {
      setLocationLoading(prev => ({ ...prev, [pid]: false }));
      window.open(url, '_blank', 'noopener,noreferrer');
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        ({ coords: c }) => {
          const dest =
            currentPropertyData.lat && currentPropertyData.lng
              ? `https://www.google.com/maps/dir/?api=1&origin=${c.latitude},${c.longitude}&destination=${currentPropertyData.lat},${currentPropertyData.lng}&travelmode=driving`
              : fallback;
          open(dest);
        },
        () => open(fallback),
        { timeout: 10000 }
      );
    } else {
      open(fallback);
    }
  }, [currentPropertyData]);

  // ── Card renderer ─────────────────────────────────────────────────────────
  const renderCard = useCallback((property) => {
    if (!property || property.id == null) return null;

    const imgIdx = currentImageIndex[property.id] || 0;
    const images = property.images?.length ? property.images : [buildingImage];

    const postedBy = property.postedBy || property.posted_by || 'Agent';
    const facing = property.facing || '-';

    const priceValue =
      property.effectivePrice ??
      property.minBudget ??
      property.price ??
      0;

    const locationText =
      property.location || property.locality || 'Location not available';

    const saved = isSaved(property);
    const isSaving = !!saving[property.id];

    return (
      <Card
        key={property.id}
        onClick={handleCardClick(property)}
        sx={{
          mb: 1.2, mx: 2, borderRadius: 2, boxShadow: 2,
          display: 'flex', flexDirection: 'row',
          width: 'auto', height: 170, overflow: 'hidden',
          transition: 'transform 0.2s ease-in-out',
          '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
          bgcolor: '#fff', flexShrink: 0, cursor: 'pointer',
        }}
      >
        {/* LEFT: Image 38% */}
        <Box sx={{ position: 'relative', width: '38%', minWidth: '38%', height: '100%', overflow: 'hidden' }}>
          <CardMedia
            component="img"
            image={images[imgIdx]}
            alt={property.title}
            onError={(e) => { e.target.src = buildingImage; }}
            sx={{
              width: '100%', height: '100%', objectFit: 'cover',
              borderTopLeftRadius: 8, borderBottomLeftRadius: 8,
            }}
          />

          <Tooltip title={saved ? 'Remove from Wishlist' : 'Add to Wishlist'}>
            <IconButton
              onClick={(e) => handleWishlistClick(e, property)}
              disabled={isSaving}
              sx={{
                position: 'absolute', top: 7, right: 3,
                bgcolor: 'white', boxShadow: 1, p: 0.5, width: 24, height: 24,
                '&:hover': { bgcolor: '#f5f5f5' },
              }}
            >
              {isSaving ? (
                <CircularProgress size={16} />
              ) : saved ? (
                <Favorite color="error" fontSize="small" />
              ) : (
                <FavoriteBorder sx={{ fontSize: '1rem', color: '#c98a2c' }} />
              )}
            </IconButton>
          </Tooltip>

          {property.listingType && (
            <Box sx={{
              position: 'absolute', top: 7, left: 5,
              bgcolor: 'rgba(0,0,0,0.65)', color: '#fff',
              px: 0.7, py: 0.2, borderRadius: '3px',
              fontSize: '0.55rem', fontWeight: 600,
              textTransform: 'uppercase',
            }}>
              {property.listingType}
            </Box>
          )}

          {/* Distance badge */}
          {property.distance_km != null && property.distance_km < 99999 && (
            <Box sx={{
              position: 'absolute', bottom: 6, left: 5,
              bgcolor: 'rgba(0,0,0,0.65)', color: '#fff',
              px: 0.7, py: 0.2, borderRadius: '3px',
              fontSize: '0.55rem', fontWeight: 600,
            }}>
              {formatDistance(property.distance_km)}
            </Box>
          )}
        </Box>

        {/* RIGHT: Content 62% */}
        <CardContent
          sx={{
            width: '62%', p: 1,
            display: 'flex', flexDirection: 'column',
            justifyContent: 'space-between',
            height: 170, boxSizing: 'border-box',
            '&:last-child': { pb: 1 },
          }}
        >
          {/* Title + Share */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.2 }}>
            <Typography
              fontWeight="bold" noWrap
              sx={{
                flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis',
                fontSize: '0.75rem', lineHeight: 1.2, color: '#2C1810', mr: 0.3,
              }}
            >
              {property.title}
            </Typography>
            <IconButton
              onClick={(e) => handleShareClick(e, property)}
              size="small"
              sx={{
                width: 25, height: 25, p: 0, flexShrink: 0,
                bgcolor: '#FFFFFF', boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
                '&:hover': { bgcolor: '#F5EDE4' },
              }}
            >
              <Share sx={{ fontSize: 14, color: '#8D6E63' }} />
            </IconButton>
          </Box>

          {/* Budget per Acre (centered) */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 0.1, mb: 0.2 }}>
            <Box sx={{ textAlign: 'center', minWidth: 0 }}>
              <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
                Budget per Acre
              </Typography>
              <Typography fontWeight="bold" sx={{ fontSize: '0.9rem', lineHeight: 1.2, color: '#1F1F1F' }}>
                ₹{formatTotalPrice(priceValue)}
              </Typography>
            </Box>
          </Box>

          {/* Location */}
          <Box
            // onClick={(e) => handleLocationClick(e, property)}
            role="button"
            tabIndex={0}
            sx={{
              display: 'flex', alignItems: 'flex-start', gap: 0.5,
              mt: 0.1, mb: 0.1, cursor: 'pointer',
              borderRadius: 1, px: 0.3,
              transition: 'background-color 0.15s',
              '&:hover': { backgroundColor: 'rgba(201,138,44,0.10)' },
            }}
          >
            {locationLoading[property.id] ? (
              <CircularProgress size={14} sx={{ mt: 0.15, flexShrink: 0 }} />
            ) : (
              <LocationOn sx={{ fontSize: '0.9rem', color: '#8B4F16', flexShrink: 0, mt: 0.15 }} />
            )}
            <Typography
              sx={{
                minWidth: 0, flex: 1,
                fontSize: '0.6rem',
                color: '#333',
                fontWeight: 500,
                lineHeight: 1.2,
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
                textDecoration: 'underline',
                textDecorationColor: 'rgba(201,138,44,0.4)',
              }}
            >
              {locationText}
            </Typography>
          </Box>

          {/* Info Grid */}
          <Box
            sx={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              mt: 0.2, mb: 0.2,
              border: '1px solid #e0e0e0',
              borderRadius: '8px', overflow: 'hidden', minHeight: 30,
            }}
          >
            <Box sx={{ flex: 1.2, minWidth: 0, textAlign: 'center', p: 0.4, borderRight: '1px solid #e0e0e0' }}>
              <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.62rem', lineHeight: 1.1, fontWeight: 900 }}>
                {postedBy}
              </Typography>
            </Box>

            <Box sx={{ flex: 1, minWidth: 0, textAlign: 'center', p: 0.3 }}>
              <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.62rem', lineHeight: 1.1, fontWeight: 900 }}>
                {facing}
              </Typography>
              <Typography noWrap sx={{ fontSize: '0.55rem', lineHeight: 1.1, color: '#666' }}>
                Facing
              </Typography>
            </Box>
          </Box>

          {/* View Details */}
          <Button
            variant="contained"
            size="small"
            fullWidth
            onClick={handleViewDetails(property)}
            sx={{
              mt: 0.2, py: 0.18,
              fontSize: '0.7rem', fontWeight: 600,
              bgcolor: '#8B4F16', color: '#fff',
              borderRadius: '2px',
              '&:hover': { bgcolor: '#f5f5f5' },
              textTransform: 'none',
              minHeight: 22,
              display: 'flex', justifyContent: 'space-between',
              alignItems: 'center', px: 1.5,
            }}
          >
            View Details
            <ArrowForward sx={{ fontSize: '0.9rem' }} />
          </Button>
        </CardContent>
      </Card>
    );
  }, [
    currentImageIndex, locationLoading, saving, isSaved,
    handleCardClick, handleViewDetails,
    handleWishlistClick, handleShareClick, handleLocationClick,
  ]);

  // ── Main chips (typeOptions) ─────────────────────────────────────────────
  const renderTypeChips = () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 0.6,
        overflowX: 'auto',
        flexWrap: 'nowrap',
        pb: 0.5,
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
    >
      {(filterOptions.typeOptions || []).map((opt) => {
        if (!opt || opt.value == null) return null;
        const isActive = selectedType === opt.value;
        return (
          <Chip
            key={`type:${opt.value}`}
            label={opt.label ?? String(opt.value)}
            onClick={() => setSelectedType(prev => prev === opt.value ? null : opt.value)}
            sx={{
              flexShrink: 0,
              height: 24,
              borderRadius: '20px',
              fontWeight: 'bold',
              fontSize: '13px',
              bgcolor: isActive ? '#8B4F16' : 'transparent',
              color: isActive ? '#fff' : '#000',
              border: '1px solid black',
              transition: 'all 0.2s ease',
              cursor: 'pointer',
              '&:hover': {
                bgcolor: isActive ? '#333' : '#e0e0e0',
                transform: 'scale(1.02)',
              },
              '& .MuiChip-label': { paddingLeft: '6px', paddingRight: '6px', lineHeight: 1 },
            }}
          />
        );
      })}
    </Box>
  );

  // ── Sub chips (propertyTypeOptions) ──────────────────────────────────────
  const renderPropertyTypeChips = () => (
    <Box
      sx={{
        display: 'flex',
        gap: 0.6,
        overflowX: 'auto',
        flexWrap: 'nowrap',
        pb: 0.5,
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
    >
      {(filterOptions.propertyTypeOptions || []).map((opt) => {
        if (!opt || opt.value == null) return null;
        const isActive = selectedPropertyType === opt.value;
        return (
          <Chip
            key={`propertyType:${opt.value}`}
            label={opt.label ?? String(opt.value)}
            onClick={() => setSelectedPropertyType(prev => prev === opt.value ? null : opt.value)}
            sx={{
              flexShrink: 0,
              height: 24,
              borderRadius: '20px',
              fontWeight: 'bold',
              fontSize: '13px',
              bgcolor: isActive ? '#8B4F16' : 'transparent',
              color: isActive ? '#fff' : '#000',
              border: '1px solid black',
              transition: 'all 0.2s ease',
              cursor: 'pointer',
              '&:hover': {
                bgcolor: isActive ? '#333' : '#e0e0e0',
                transform: 'scale(1.02)',
              },
              '& .MuiChip-label': { paddingLeft: '6px', paddingRight: '6px', lineHeight: 1 },
            }}
          />
        );
      })}
    </Box>
  );

  // ── Properties section — ads after EVERY 2 cards + trailing ads ─────────
  const renderPropertiesSection = useMemo(() => {
    if (activeTab === 'jvjd' && initialLoading) {
      return (
        <Box sx={{ mt: 1 }}>
          {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
        </Box>
      );
    }

    if (activeTab === 'jvjd' && showSkeleton) {
      return (
        <Box>
          {isTyping && (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, py: 1.5 }}>
              <CircularProgress size={16} sx={{ color: '#8B7355' }} />
              <Typography variant="caption" sx={{ color: '#888' }}>Searching...</Typography>
            </Box>
          )}
          <Box sx={{ mt: isTyping ? 0.5 : 1 }}>
            {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
          </Box>
        </Box>
      );
    }

    if (properties.length === 0) {
      return (
        <Box sx={{
          display: 'flex', flexDirection: 'column', justifyContent: 'center',
          alignItems: 'center', height: 200, gap: 1, px: 2,
        }}>
          <Typography variant="body2" color="text.secondary">
            {activeTab === 'accessed'
              ? "You haven't accessed any JV/JD properties yet"
              : selectedType || selectedPropertyType || priceFilter
                ? 'No JV/JD properties match your filters.'
                : debouncedSearch
                  ? `No results for "${debouncedSearch}"`
                  : 'No JV/JD properties available right now.'}
          </Typography>
        </Box>
      );
    }

    // How many 3-ad blocks fit inline (after every 2nd property card)?
    const inlineBlockCount = Math.floor(properties.length / 2);

    return (
      <>
        {properties.filter(Boolean).map((property, index) => {
          const cardNumber = index + 1; // 1-based

          let adBlock = null;
          if (activeTab === 'jvjd' && cardNumber % 2 === 0) {
            const blockIndex = cardNumber / 2 - 1;
            const adOffset = blockIndex * 3;
            if (adOffset === 0 || adOffset < jvAds.length) {
              adBlock = (
                <Box sx={{ mb: 1.2 }} key={`ad-${adOffset}`}>
                  <AddPropertyCards
                    ads={jvAds}
                    offset={adOffset}
                    loading={adsLoading}
                  />
                </Box>
              );
            }
          }

          return (
            <React.Fragment key={property.id}>
              {renderCard(property)}
              {adBlock}
            </React.Fragment>
          );
        })}

        {/* ── TRAILING ADS: append remaining ad blocks so ALL ads render ─ */}
        {activeTab === 'jvjd' && (() => {
          const trailing = [];

          if (inlineBlockCount === 0 && adsLoading && jvAds.length === 0) {
            trailing.push(
              <Box sx={{ mb: 1.2 }} key="ad-0">
                <AddPropertyCards ads={[]} offset={0} loading={true} />
              </Box>
            );
            return trailing;
          }

          for (let i = inlineBlockCount; i * 3 < jvAds.length; i++) {
            const adOffset = i * 3;
            trailing.push(
              <Box sx={{ mb: 1.2 }} key={`ad-${adOffset}`}>
                <AddPropertyCards
                  ads={jvAds}
                  offset={adOffset}
                  loading={adsLoading}
                />
              </Box>
            );
          }
          return trailing;
        })()}

        {activeTab === 'jvjd' && (
          <ScrollSentinel onVisible={loadMore} hasMore={hasMore} loading={loadingMore} />
        )}
      </>
    );
  }, [
    activeTab, initialLoading, showSkeleton, isTyping, properties,
    selectedType, selectedPropertyType, debouncedSearch, renderCard,
    hasMore, priceFilter,
    jvAds, adsLoading,
    loadMore, loadingMore,
  ]);

  // ── JSX ───────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>
      {/* Fixed header */}
      <Box sx={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200,
        backgroundColor: 'rgb(239, 231, 221)',
      }}>
        <Box sx={{ px: 1, pt: 1, pb: 0.25 }}>
          <CustomSearchBar
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            onPriceFilterChange={(val) => {
              if (val && typeof val === 'object' && (val.min != null || val.max != null)) {
                setPriceFilter({ min: val.min ?? 0, max: val.max ?? 10000000000 });
              } else {
                setPriceFilter(null);
              }
            }}
          />
        </Box>

        {/* Two tabs */}
        <Box sx={{ px: 2, pt: 0, pb: 0.5 }}>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => {
              setActiveTab(newValue);
              if (newValue === 'accessed') {
                setSelectedType(null);
                setSelectedPropertyType(null);
                setPriceFilter(null);
              }
            }}
            sx={{ minHeight: 36, '& .MuiTabs-indicator': { backgroundColor: '#B66A18', height: 3 } }}
          >
            <Tab
              label="JV/JD Properties"
              value="jvjd"
              sx={{
                textTransform: 'none', fontWeight: 'bold',
                minWidth: 0, mr: 2, minHeight: 36, py: 0.5,
                color: 'text.secondary',
                '&.Mui-selected': { color: '#8B4F16' },
              }}
            />
            <Tab
              label="Accessed Properties"
              value="accessed"
              sx={{
                textTransform: 'none', fontWeight: 'bold',
                minWidth: 0, minHeight: 36, py: 0.5,
                color: 'text.secondary',
                '&.Mui-selected': { color: '#8B4F16' },
              }}
            />
          </Tabs>
        </Box>

        {/* Two chip rows */}
        {activeTab === 'jvjd' && (
          <>
            <Box sx={{ px: 2, pt: 0, pb: 0.25 }}>
              {filtersLoading ? <ChipRowSkeleton /> : renderTypeChips()}
            </Box>

            <Box sx={{ px: 2, pt: 0, pb: 0.5 }}>
              {filtersLoading ? <ChipRowSkeleton /> : renderPropertyTypeChips()}
            </Box>
          </>
        )}
      </Box>

      {/* Scrollable list */}
      <Box
        sx={{
          pb: 8,
          pt: activeTab === 'jvjd'
            ? { xs: '155px', sm: '160px' }
            : { xs: '100px', sm: '92px' },
        }}
      >
        {renderPropertiesSection}
      </Box>

      <GuestLoginModal open={showGuestModal} onClose={() => setShowGuestModal(false)} />

      <LocationModal
        open={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        onOpenMap={openGoogleMaps}
        propertyLocation={currentPropertyData?.location}
      />

      <ShareModal
        open={showShareModal}
        onClose={() => setShowShareModal(false)}
        ownerName={currentPropertyData?.postedBy || currentPropertyData?.posted_by || 'Agent'}
        mobileNo={currentPropertyData?.mobile_no}
      />

      <AlertModal
        open={showWishlistSuccess}
        onClose={() => setShowWishlistSuccess(false)}
        title={wishlistSuccessMsg.title}
        message={wishlistSuccessMsg.message}
        isSuccess={true}
      />

      <CustomBottomNav />
    </Box>
  );
};

export default JvJdPropertyList;